export const productsNumber = 100;
